import React from "react";
import { Typography } from "@mui/material";
import { redirectToVanillaPortal } from "../../helpers/HelperFunction";
import { portalOwnerTypeFromEntity } from "./donationLinkReviewQueue";

interface DonationEntityIdLinkProps {
  entityId?: string | null;
  entityType?: string | null;
  label?: string | null;
}

const DonationEntityIdLink = ({
  entityId,
  entityType,
  label,
}: DonationEntityIdLinkProps) => {
  const id = entityId?.trim();
  const text = label?.trim() || id;
  if (!id) {
    return (
      <Typography variant="body2" component="span">
        —
      </Typography>
    );
  }

  const ownerType = portalOwnerTypeFromEntity(entityType);
  if (!ownerType) {
    return (
      <Typography variant="body2" component="span" title={id}>
        {text}
      </Typography>
    );
  }

  return (
    <Typography
      component="button"
      type="button"
      variant="body2"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        redirectToVanillaPortal(id, ownerType);
      }}
      title={id}
      sx={{
        cursor: "pointer",
        border: "none",
        background: "none",
        padding: 0,
        font: "inherit",
        color: "primary.main",
        textDecoration: "underline",
        textAlign: "left",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: "100%",
      }}
    >
      {text}
    </Typography>
  );
};

export default DonationEntityIdLink;
